import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { CustomSelect, Modal } from 'src/components';
import Button from 'src/components/button';
import SlideInModal from 'src/components/slideInModal';
import TextField from 'src/components/text-field';
import { fetchDesignation } from 'src/redux/action/designation.action';
import { fetchEmployee } from 'src/redux/action/employee.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface IProps {
  handleModal: () => void;
  // onClick: () => void;
  showModal: boolean;
  isHidden: boolean;
  setIsEdit: (val: boolean) => void;
  setIsHidden: any;
  setEditId: (val: string) => void;
  generateRandomDigits: (e: any) => void;
  isEdit: boolean;
  editId: string;
  token?: string;
  editEmployeeData: any;
}
type employeePostValue = {
  name: string;
  email: string;
  phone: string;
  designationId: string;
  image: string;
};

const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Full Name must a at least 3 character long')
    .required('Full Name is required'),
  email: Yup.string()
    .email()
    .typeError('Please enter a valid email')
    .required('Email is required'),
  // email: Yup.string()
  //   .test('custom-email', 'Please enter a valid email', customEmailValidation)
  //   .required('Email is required'),
  phone: Yup.number()
    .typeError('Phone number must be in number')
    .required('Phone number is required'),
  designationId: Yup.string().required('Designation is required'),
  // code: Yup.number()
  //   .typeError('Pin  number must be in number')
  //   .required('Pin number is required'),
  // image: Yup.string().required('reuired'),
});

const AddEmployee: React.FC<IProps> = ({
  showModal,
  handleModal,
  editId,
  isEdit,
  setEditId,
  setIsHidden,
  setIsEdit,
  editEmployeeData,
  // onClick,
  isHidden,
  generateRandomDigits,
  token,
}) => {
  const [code, setCode] = useState<any>('');
  useEffect(() => {
    if (editEmployeeData) {
      setCode(editEmployeeData?.pin ?? '');
    }
  }, [editEmployeeData]);
  const dispatch = useDispatch();
  const [previewImage, setPreviewImage] = React.useState<any>(null);
  const [errorMsgPost, setErrorMsgPost] = React.useState('');
  const [removeImage, setRemoveImage] = useState(false);
  const handleChange = (code: string) => {
    setCode(code);
  };
  const handleImageClose = () => {
    setIsHidden(true);
    setPreviewImage('');
    setRemoveImage(true);
  };

  const { designationData } = useSelector(
    ({ designationData }: RootState) => designationData
  );
  React.useEffect(() => {
    if (designationData.length > 0) return;
    dispatch(fetchDesignation() as any);
  }, [dispatch]);

  const intValues = {
    name: isEdit ? editEmployeeData?.name : '',
    email: isEdit ? editEmployeeData?.email : '',
    phone: isEdit ? editEmployeeData.phone : '',
    designationId: isEdit ? editEmployeeData?.designation?.id : '',
    image: isEdit ? editEmployeeData?.image : '',
    // pin: isEdit ? editEmployeeData?.pin: '',
  };

  const handleSubmit = async (val: employeePostValue) => {
    const payload = {
      ...val,
      image: '',
      // image: removeImage ? '' : val?.image,
      // image: val.image,
      id: editId,
      pin: code,
    };

    try {
      if (editId) {
        await Service.put('/employees/edit', payload);
      } else {
        await Service.post('/employees/create', payload);
      }
      handleModal();
      toastAlert(
        'success',
        `Employee  ${val?.name} is successfully ${editId ? 'edited' : 'added'}`
      );
      dispatch(fetchEmployee() as any);
      setIsEdit(false);
      setEditId('');
    } catch (err: any) {
      setErrorMsgPost(err?.response?.data?.message);
      setIsEdit(false);
      setEditId('');
    }
  };

  const ownerData: any = [{ name: 'Owner', id: '1' }];

  return (
    <>
      {showModal && (
        <SlideInModal
          showModal={showModal}
          title={isEdit ? 'Edit Employee' : 'Add Employee'}
          onClick={handleModal}
          className="h-[550px] overflow-y-auto w-[500px] bg-pure-white z-[9999]"
        >
          <div className="mx-5 mt-4">
            {errorMsgPost && !isEdit && (
              <p className="text-warning text-center text-sm font-semibold capitalize">
                {errorMsgPost}
              </p>
            )}
            <Formik
              initialValues={intValues}
              validateOnMount
              validationSchema={FORM_VALIDATION}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ isSubmitting, isValid, setFieldValue }) => (
                <Form className="mt-5">
                  <TextField
                    label="Full Name"
                    name="name"
                    defaultValue={editEmployeeData?.name}
                  />
                  <TextField
                    label="Email Address"
                    name="email"
                    defaultValue={editEmployeeData?.email}
                  />
                  <TextField
                    label="Phone Number"
                    name="phone"
                    defaultValue={editEmployeeData?.phone}
                    type="text"
                  />
                  <Field
                    name="designationId"
                    className="mt-3"
                    options={
                      isEdit &&
                      editEmployeeData &&
                      editEmployeeData?.designation?.isEditable == true
                        ? designationData
                        : editEmployeeData?.designation?.isEditable == false
                        ? ownerData
                        : designationData
                    }
                    component={CustomSelect}
                    // defaultValue={
                    //   isEdit &&
                    //   editEmployeeData &&
                    //   editEmployeeData?.designation?.isEditable == true
                    //     ? editEmployeeData?.designation?.title
                    //     : editEmployeeData?.designation?.isEditable == false
                    //     ? 'Owner'
                    //     : ''
                    // }
                    defaultValue={editEmployeeData?.designation?.title}
                    // disable={
                    //   isEdit &&
                    //   editEmployeeData &&
                    //   editEmployeeData?.designation?.isEditable === true
                    //     ? false
                    //     : editEmployeeData?.designation?.isEditable === false
                    //     ? true
                    //     : false
                    // }
                    disable={
                      editEmployeeData?.designation?.isEditable === false
                    }
                    isMulti={false}
                    label="Designation"
                  />
                  <div className="mb-8">
                    <div className="flex justify-between">
                      <label htmlFor="">PIN</label>
                      {/* <button
                        className="cursor-pointer text-[white] bg-primary p-2 px-3 rounded-xl"
                        onClick={(e:any)=>generateRandomDigits(e)}
                        type="button"
                      >
                        Generate Token
                      </button> */}
                    </div>
                    <OtpInput
                      containerStyle={{
                        justifyContent: 'space-between',
                      }}
                      value={code}
                      onChange={handleChange}
                      numInputs={4}
                      separator={<span style={{ width: '20px' }}></span>}
                      isInputNum={true}
                      shouldAutoFocus={true}
                      className="mt-5"
                      inputStyle={{
                        border: '1px solid #CACFE3',
                        borderRadius: '8px',
                        width: '48px',
                        height: '56px',
                        fontSize: '15px',
                        color: '#000',
                        fontWeight: '400',
                      }}
                      focusStyle={{
                        border: '1px solid #4062FF',
                        outline: 'none',
                      }}
                    />
                  </div>

                  <div className="flex items-center justify-end mt-10">
                    <Button
                      text={isEdit ? 'Edit Employee' : 'Add Employee'}
                      variant="primary"
                      type="submit"
                      isSubmitting={isSubmitting}
                      isValid={isValid}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </SlideInModal>
      )}
    </>
  );
};

export default React.memo(AddEmployee);
